module.exports = __webpack_public_path__ + "img/icon-corona-menu-covid.9a5d711d.svg";